<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="用户uid" prop="uid">
              <a-input v-model="formInline.uid" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="手机号码" prop="phone">
              <a-input v-model="formInline.phone" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="负责人姓名" prop="settledName">
              <a-input
                v-model="formInline.settledName"
                type="user"
                placeholder="请输入"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" html-type="submit"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <proxyAuditContent
          :formInline="formInline"
          ref="aaa"
        ></proxyAuditContent>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import proxyAuditContent from "./proxyAuditContentTwo.vue";
export default {
  components: {
    proxyAuditContent,
  },
  data() {
    return {
      formInline: {
        uid: "",
        phone: "",
        settledName: "",
        limit: 10,
        page: 1,
      },
    };
  },
  methods: {
    handleSubmit(e) {
      console.log(this.formInline);
      this.$refs.aaa.query();
    },
    resetForm() {
      console.log(111);
      this.$refs.aaa.getStoreDistributorsList();
      this.formInline.uid = "";
      this.formInline.phone = "";
      this.formInline.settledName = "";
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/proxyAuditTwo/proxyAuditTwo.vue